import BaseAPI from "./base/base-api";

class JobTitleAPI extends BaseAPI {
  constructor() {
    super();
  }
  apiName = "Business";
  controllerName = "JobTitle";
}

export default new JobTitleAPI();
